// assets
import {
  IconAward,
  IconBriefcase,
  IconChecklist,
  IconHeartHandshake,
  IconTimeline,
} from "@tabler/icons-react";

const career = {
  id: "experience",
  title: "Experience",
  type: "group",
  children: [
    {
      id: "professional",
      title: "Professional",
      type: "item",
      url: "/professional",
      icon: IconBriefcase,
      breadcrumbs: false,
      color: "#4caf50", // green
    },
    {
      id: "impact",
      title: "Social Impact",
      type: "item",
      url: "/impact",
      icon: IconHeartHandshake,
      breadcrumbs: false,
      color: "#f50057", // pink
    },
    {
      id: "awards",
      title: "Awards",
      type: "item",
      url: "/awards",
      icon: IconAward,
      breadcrumbs: false,
      color: "#ffc107", // amber
    },
    {
      id: "resumes",
      title: "Resumes",
      type: "item",
      url: "/resumes",
      icon: IconChecklist,
      breadcrumbs: false,
      color: "#4caf50", // green
      visible: false,
    },
    {
      id: "timeline",
      title: "Timeline",
      type: "item",
      url: "/timeline",
      icon: IconTimeline,
      breadcrumbs: false,
      color: "#ff1744", // red
      visible: false,
    },
  ],
};

export default career;
